import "./Footer.css";

const Footer = () => {
  return (
    <div className="root">
      {/* Horizontal */}
      <div>
        <p>SARC</p>
      </div>
    </div>
  );
};

export default Footer;
